import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import Table from 'rc-table';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { createStructuredSelector } from 'reselect';
import { selectWorkflows } from '../selectors';
import { BaseComponent } from '../../../components/BaseComponent';
import { WorkflowActionsContainer } from './WorkflowActionsContainer';
import { WORKFLOW_STATUSES } from '../constants';

const Container = styled.div`
  width: 100%;
  background: white;
`;

const CustomTable = styled(Table)`
  width: 100%;
  display: flex;
  font-size: 12px;

  .rc-table-container {
    width: 100%;
  }

  .rc-table-content table {
    width: 100%;
  }

  .rc-table-thead {
    background-color: #eff1f7;
    font-weight: 600;
    height: 52px;
    padding: 16px 0;
    margin-left: 8px;
    font-size: 14px;
  }

  td,
  th {
    padding: 8px 12px;
  }
`;

/* eslint-disable react/prefer-stateless-function */
class WorkflowsOverviewTableComp extends BaseComponent {
  constructor(props) {
    super(props);
  }

  get workflows() {
    return this.props.workflows;
  }

  getData = workflow => {
    return {
      id: workflow.id,
      name: workflow.name,
      actions: workflow,
    };
  };

  getColumns = () => {
    return [
      {
        title: this.lblStr('workflows.column.id'),
        dataIndex: 'id',
        key: 'id',
        align: 'left',
        render(value) {
          return <div>{value}</div>;
        },
      },
      { title: this.lblStr('workflows.column.name'), dataIndex: 'name', key: 'name', align: 'left' },
      {
        key: 'actions',
        dataIndex: 'actions',
        render(value, row, index) {
          return value.status === WORKFLOW_STATUSES.FINAL ? '' : <WorkflowActionsContainer workflow={value} />;
        },
      },
    ];
  };

  to(url, newWindow) {
    //
    if (newWindow) {
      window.open(url);
    } else {
      this.props.history.push(url);
    }
  }

  // onClickDeleteBtn() {
  //   this.setState({ removeWorkflowConfirmation: true });
  // }

  render() {
    const columns = this.getColumns();
    const data = this.workflows?.map(w => this.getData(w));

    return (
      <Container>
        <CustomTable
          columns={columns}
          data={data}
          scroll={{ x: window.innerWidth < 975 ? 975 : false }}
          emptyText={'No workflows found by current filters'}
          onRow={(record, index) => {
            return {
              onClick: () => {
                return this.to(`/workflows/${record.id}`);
              },

              workflow: this.props.workflows[index],
            };
          }}
        />
      </Container>
    );
  }
}

WorkflowsOverviewTableComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  onItemClick: PropTypes.func,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    workflows: selectWorkflows(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const WorkflowsOverviewTable = compose(withConnect, withRouter, injectIntl)(WorkflowsOverviewTableComp);
